var map = {
	"./caiwu.svg": "./src/icons/svg/caiwu.svg",
	"./chunbo.svg": "./src/icons/svg/chunbo.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./dingdan.svg": "./src/icons/svg/dingdan.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./fenzhang.svg": "./src/icons/svg/fenzhang.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fuwu.svg": "./src/icons/svg/fuwu.svg",
	"./geren.svg": "./src/icons/svg/geren.svg",
	"./gongzuotai.svg": "./src/icons/svg/gongzuotai.svg",
	"./jichu.svg": "./src/icons/svg/jichu.svg",
	"./jinhuo.svg": "./src/icons/svg/jinhuo.svg",
	"./kucun.svg": "./src/icons/svg/kucun.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pingtaishangpin.svg": "./src/icons/svg/pingtaishangpin.svg",
	"./shangpin.svg": "./src/icons/svg/shangpin.svg",
	"./shangpu.svg": "./src/icons/svg/shangpu.svg",
	"./shenhe.svg": "./src/icons/svg/shenhe.svg",
	"./shenhezhongxin.svg": "./src/icons/svg/shenhezhongxin.svg",
	"./shezhi.svg": "./src/icons/svg/shezhi.svg",
	"./shezhitubiao.svg": "./src/icons/svg/shezhitubiao.svg",
	"./shouye.svg": "./src/icons/svg/shouye.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./tixian.svg": "./src/icons/svg/tixian.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./xiaoshou.svg": "./src/icons/svg/xiaoshou.svg",
	"./yaopin.svg": "./src/icons/svg/yaopin.svg",
	"./zhensuo.svg": "./src/icons/svg/zhensuo.svg",
	"./zizhi.svg": "./src/icons/svg/zizhi.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";